function ModuleListItemController() {
  const ctrl = this;

  ctrl.$onChanges = () => {
    ctrl.processVersionStatus();
  };

  ctrl.processVersionStatus = () => {
    ctrl.versionStatus = ctrl.softwareStatus();
    ctrl.upgradeFlag = ctrl.getUpgradeStatus();
  };

  ctrl.getUpgradeStatus = () => {
    // Virtual modules do not have sw or hw versions
    if (!ctrl.module.sw_upgrade_available) return false;

    let swUpgradeStatus = false;
    if (ctrl.module.sw_upgrade_available.length > 0) {
      ctrl.module.sw_upgrade_available.forEach(module => {
        if (
          module.descriptor === 'Engineering' &&
          (ctrl.module.software_version_status === 'Engineering' ||
            ctrl.module.software_version_status === 'Valid' ||
            ctrl.module.software_version_status === 'Sanctioned')
        ) {
          if (module.date_created > ctrl.module.software_version_date_created) {
            if (module.version_number !== ctrl.module.software_version) {
              swUpgradeStatus = true;
            }
          }
        } else if (module.descriptor === 'Sanctioned' && ctrl.module.software_version_status === 'Sanctioned') {
          swUpgradeStatus = false;
        } else if (module.descriptor === 'Valid' && (ctrl.module.software_version_status === 'Valid' || ctrl.module.software_version_status === 'Engineering' || ctrl.module.software_version_status === 'Sanctioned')) {
          swUpgradeStatus = false;
        } else {
          if (module.version_number !== ctrl.module.software_version) {
            swUpgradeStatus = true;
          }
        }
      });
    }
    return swUpgradeStatus;
  };

  ctrl.hardwareStatus = () => {
    if (ctrl.module.hardware_version_status === 'Deprecated') {
      return 'Deprecated';
    } else if (ctrl.module.hardware_version_status === 'Unknown') {
      return 'Unknown';
    } else if (ctrl.module.hardware_version_status === 'Engineering') {
      return 'Engineering';
    } else if (ctrl.module.hardware_version_status === 'Valid') {
      return 'Valid';
    } else if (ctrl.module.hardware_version_status === 'Sanctioned') {
      return 'Sanctioned';
    } else {
      return 'Virtual';
    }
  };

  ctrl.softwareStatus = () => {
    if (ctrl.module.software_version_status === 'Deprecated') {
      return 'Deprecated';
    } else if (ctrl.module.software_version_status === 'Unknown') {
      return 'Unknown';
    } else if (ctrl.module.software_version_status === 'Engineering') {
      return 'Engineering';
    } else if (ctrl.module.software_version_status === 'Valid') {
      return 'Valid';
    } else if (ctrl.module.software_version_status === 'Sanctioned') {
      return 'Sanctioned';
    } else {
      return 'Virtual';
    }
  };

  ctrl.selectSub = event => {
    ctrl.onSelect({
      $event: {
        module: event.module,
      },
    });
  };

  ctrl.selectModule = module => {
    ctrl.activeModule = module;
    ctrl.onSelect({
      $event: {
        module: module,
      },
    });
  };
}

angular.module('configuration-management.module').controller('ModuleListItemController', ModuleListItemController);
